import { initReactI18next } from 'react-i18next';
import i18next from 'i18next';

import translation from './en/translation.json';

// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18next.use(initReactI18next).init({
  lng: 'en', // if you're using a language detector, do not define the lng option
  debug: true,
  resources: {
    en: {
      translation,
    },
  },
  interpolation: { escapeValue: false },
});

export default i18next;
